import React from 'react';
import { useNavigate } from 'react-router-dom';

export interface WithNavigationProps {
  navigate: (path: string) => void;
}

export const withNavigation = <P extends object>(Component: React.ComponentType<P>) => {
  return (props: Omit<P, keyof WithNavigationProps>) => {
    const navigate = useNavigate();
    return <Component {...(props as P)} navigate={navigate} />;
  };
}; 